export enum MileId {
  All,
  Mile1,
  Mile2,
  Mile3,
  MileSpecial,
  AllMiles,
  AllBars,
  Mile25,
  Mile4,
  Mile5,
  Mile6,
  Mile7,
}

export enum BarId {
  Samocvet = "Samocvet",
  InTouch = "InTouch",
  Bones50 = "Bones50",
  Nelson = "Nelson",
  Americanka = "Americanka",
  Killfish = "Killfish",
  Kam = "Kam",
  Three = "Three",
  Prorock = "Prorock",
  DvaDeda = "DvaDeda",
  Health = "Health",
  Irish = "Irish",
  InnocentPeople = "InnocentPeople",
  Pravda = "Pravda",
  NeBar = "NeBar",
  Mon = "Mon",
  Sova = "Sova",
  Mango = "Mango",
  Kaifooi = "Kaifooi",
  OurBar = "OurBar",
  Nravs = "Nravs",
  TheOutBar = "TheOutBar",
  Stereotypes = "Stereotypes",
  Television = "Television",
  Strelka = "Strelka",
  Sbors = "Sbors",
  Collective = "Collective",
  DoubleGrill = "DoubleGrill",
  Gastrols = "Gastrols",
  Baiks = "Baiks",
  Tarantino = "Tarantino",
  Slova = "Slova",
  NewBar = "NewBar",
  Fireside = "Fireside",
  Grott = "Grott",
  StayTrue = "StayTrue",
  Lovecraft = "Lovecraft",
  RustyDed = "RustyDed",
  Kotze = "Kotze",
  Mishka = "Mishka",
  Poison = "Poison",
  Teremok = "Teremok",
  Dogma = "Dogma",
  Misantrope = "Misantrope",
  Boroda = "Boroda",
  BioShmio = "DioShmio",
  PushInBar = "PushInBar",
  Spletni = "Spletni",
  Geograf = "Geograf",
  Izakaya = "Izakaya",
  Kritik = "Kritik",
  SleepingDog = "SleepingDog",
  Mivino = "Mivino",
  Bukowski = "Bukowski",
  Opyt = "Opyt",
  Melody = "Melody",
  RosyJane = "RosyJane",
  Fjord = "Fjord",
  RedCooper = "RedCooper",
  UncleHoward = "UncleHoward",
  Air = "Air",
  BenHall = "BenHall",
  Mom = "Mom",
  Yankee = "Yankee",
  Mint = "Mint",
  TacoMago = "TacoMago",
  Amigos = "Amigos",
  Stavnikov = "Stavnikov",
  Pils = "Pils",
  Onegin = "Onegin",
  GrottSpot = "GrottSpot",
  Podpolie = "Podpolie",
  ForeverYoung = "ForeverYoung",
  BreakingBad = "BreakingBad",
  Bushes = "Bushes",
  Salut = "Salut",
  Pocherk = "Pocherk",
}

export enum DiggerId {
  Kvertinsky = "Kvertinsky",
  Kot = "Kot",
  Kokos = "Kokos",
  Lex = "Lex",
  Lada = "Lada",
  Mihael = "Mihael",
  Eduard = "Ed",
  Ge = "Ge",
  Gleb = "Gl",
  Evgenia = "Ev",
  Jopa = "Jopa_sjela_volka",
  Lena = "Lena",
  Ilya = "Il",
  Dima = "Di",
  An = "An",
  Sempai = "Sempai",
  Artem = "Artem",
  Daria = "Dar",
  Plur = "Plur",
  Vadim = "Vadim",
  Maria = "Maria",
  Sasha = "Sasha",
  Ivan = "Ivan",
  Alexa = "Alexa",
  Anatoly = "Anatoly",
  Mashulkins = "Mashulkins",
  Anton = "Anton",
  Sevara = "Sevara",
  Sun = "Sun",
}

export enum DiggerBadgeId {
  Father = "Father",
  WhiteRussian = "WhiteRussian",
  StairsSlayer = "StairsSlayer",
  Longliver = "Longliver",
  Firebender = "Firebender",
}

export enum BarBadgeId {
  GoodCocktails,
  UniqueCocktails,
  GoodTincture,
  GoodBeer,
  CraftBeer,
  DancePool,
  GoodDesign,
  Sabotage,
  Hookah,
  BadMusic,
  Games,
  BadBeer,
  GoodMusic,
}
